import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useUpdateChecklist } from '../../queries/use-update-checklist';

type ChecklistDefaultConfirmProps = {
    checklistId: string;
    isOpen: boolean;
    onClose: () => void;
    onSet: () => void;
};

function ChecklistDefaultConfirm({ checklistId, isOpen, onClose, onSet }: ChecklistDefaultConfirmProps): JSX.Element {
    const updateChecklistQuery = useUpdateChecklist(checklistId);

    function updateChecklist(): void {
        updateChecklistQuery.mutate(
            { default: true },
            {
                onSuccess: () => {
                    onSet();
                    toastNotification('success', 'Default checklist updated!');
                },
                onError: () => {
                    toastNotification('error', 'Default checklist cannot be updated!');
                },
            }
        );
    }

    return (
        <Dialog
            title="Set as Default Checklist"
            description="Do you want to use this checklist as the default when creating new workpapers?"
            isOpen={isOpen}
            primaryAction="Confirm"
            secondaryAction="Cancel"
            type="info"
            onClose={onClose}
            onPrimaryActionClick={updateChecklist}
            onSecondaryActionClick={onClose}
            isLoading={updateChecklistQuery.isLoading}
        />
    );
}

export default ChecklistDefaultConfirm;
